<template>
    <div class="SX">
       <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">首页></span>
        <span @click="GoSiXiang">巡视巡察></span>
          <span @click="GoBJ">北京动态></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
    <div class="zhengwen">
      <h1>中共南京新农发展集团有限责任公司党委关于巡察整改情况的通报</h1>
      <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
      <div class="second">
        <p>根据市委统一部署，2016年12月3日至2017年1月25日，市委第六巡察组对南京新农发展集团有限责任公司党委进行了巡察。2017年2月21日，市委第六巡察组向南京新农发展集团有限责任公司党委反馈了巡察意见。按照党务公开原则和巡察工作有关要求，现将巡察整改情况予以公布。 </p>

        <strong><p>　一、齐心协力，认真落实整改责任 </p></strong>

        <p>（一）加强组织领导。成立集团巡察整改工作领导小组，由集团党委负责人任组长，集团各党委委员任副组长，集团各部门负责人及子企业党组织负责人为成员，负责巡察反馈问题整改工作的统筹、协调和督查等工作。</p>

        <p>（二）制定整改方案。一是制定集团整改方案。市委巡察反馈意见后，集团党委立即召开专题会议研究制定整改落实方案，梳理出当前存在的16个方面问题，对应制定了42条整改措施，明确分管领导、责任（单位）部门、整改进度；二是制定部门及子企业整改方案。根据集团巡察整改方案要求，集团各部门及一级子企业在一周内制定了本部门、本企业的整改方案，共梳理问题48条，制定对应整改措施110条，作为本年度重点工作有序推进，确保完成整改任务。  
　　（三）强化整改督查跟进。为推进市委巡察整改工作落实，3月28日，集团召开了落实市委巡察整改工作推进会。各部门、各子企业负责人，在会上交流本部门、本单位现阶段整改工作落实推进情况并汇报了下一步整改工作安排。集团党委有关领导对后续整改工作提出明确要求，积极推进各级各项整改措施落地、落实、落细。 </p>
          <strong><p>　　　二、提高认识，夯实整改思想基础  </p></strong>

        <p>（一）抓好集团领导率先垂范。2月21日下午，集团党委召开专题党委会，党委负责人施泽平同志向全体党委委员通报了巡察反馈问题，提出五点要求：一要加强政治理论学习；二要以上率下主动自查；三要切实履行“一岗双责”；四要以身作则抓好党风廉政建设；五要抓好整改宣传培训。 </p>

        <p>（二）抓好子企业学习指导。2月22日上午，集团召开所属一级子企业党组织负责人会议，对市委巡察反馈意见进行再学习再领会，明确提出“六项要求”：一是不断深化对市委巡察工作的认识；二是坚持问题导向抓好相关问题的整改；三是切实抓好班子自身建设和党员的教育管理；四是切实加强基层党组织建设；五是认真履行全面从严治党和“一岗双责”职能；六是以巡察整改为契机迎难而上奋力爬坡。各基层党组织按照要求，随即召开本单位党委（支委）会议，进行学习传达，学习落实情况通过集团内网进行宣传交流，切实筑牢集团上下步调一致抓整改、同频共振促发展的思想基础。</p>
      </div>
    </div>
      
    
    </div>


    </div>
</template>
<script>
export default {
    methods: {
         GoRisk() {
      this.$router.push("/HOME");
    },
   GoSiXiang() {
      this.$router.push("/MakeInspectionTour");
    },
    GoBJ() {
      this.$router.push("/MakeInspectionTour/BeiJing");
    },
    },
    
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.si{
   margin: 0 16px;
 }
</style>